import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'bordbestilling',
    [ORDER_METHODS.PICKUP]: 'afhentning',
    [ORDER_METHODS.DELIVERY]: 'levering',
  },
  errors: {
    draft_validation_failed: 'Udfyld din leveringsadresse, før du fortsætter.',
  },
};
